module.exports = __webpack_public_path__ + "img/intro1_logo_active.e06eead3.png";